import { useSnackbar } from 'notistack';
import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom'
import DenseAppBar from '../../components/AppBar'
import { getCurrency, getDateTime } from '../../helpers/Functions';
import { Reducers } from '../../Interfaces/Interfaces';
import { getPOSTransactionDetails } from '../../redux/actions/POSAction';
import PrimaryTheme from '../../Themes/Primary'
import "./pos.scss"
export default function PosTransactionDetails() {

  const alert = useSelector((state: Reducers) => state.alert);
  const transactions = useSelector((state: Reducers) => state.transactions);
  // console.log(transactions)

  const history = useHistory();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const params: any = useParams();

  const handleRefresh = () => {
    dispatch({
      type: 'LOADING',
      payload: true
    });
    dispatch(getPOSTransactionDetails(params.id));
  }

  React.useEffect(() => {
    dispatch({
      type: 'LOADING',
      payload: true
    });

    dispatch(getPOSTransactionDetails(params.id));

    return () => {
      dispatch({
        type: "TRANSACTIONS",
        payload: {}
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);


  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        // display error message
        enqueueSnackbar(alert.message, { variant: "error" });

        dispatch({
          type: 'LOADING',
          payload: false
        })

        dispatch({
          type: 'ALERT',
          payload: {}
        });


      } else {

        handleRefresh();

        if (alert.message === "Successful") {
          enqueueSnackbar(alert.message, { variant: "success" });
        }

        dispatch({
          type: 'LOADING',
          payload: false
        })

        dispatch({
          type: 'ALERT',
          payload: {}
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, enqueueSnackbar, alert, history]);

  return (
    <React.Fragment>
      <div className="col-md-11 mr-auto ml-auto p-0" style={{
        height: 'auto',
        position: "relative",
       
      }}>
        <DenseAppBar
          onClick={() => history.goBack()}
          canGoBack
        />
      </div>
      <div className='col-md-12 pl-0 pr-0' style={{
        // overflow: "auto",
        backgroundColor: PrimaryTheme.white,
       
        // height: '100vh',
      }}>

        <div className="col-md-11 ml-auto mr-auto p-0 mb-5" style={{
          backgroundColor: PrimaryTheme.white,
          height: '100vh',
          position: 'relative',
         
        }}>
          <h1 className="mb-5 pos-transaction-details" style={{
            fontFamily: PrimaryTheme.fonts?.MediumFont,
            textTransform: "uppercase",
            fontSize: PrimaryTheme.fontSizes?.subtitle
          }}>POS Transaction Details</h1>


          <div className="col-md-8 ml-auto mr-auto" style={{ paddingBottom: "50px"}}>
            <h6 className="text-center" style={{
              fontFamily: PrimaryTheme.fonts?.MediumFont,
              color: PrimaryTheme.primary,
              textTransform: "uppercase",

            }}>Amount</h6>
            <h4 className="text-center">{transactions.amount ? getCurrency(transactions.amount) : "-"}</h4>

            <div className="row">
              <div className="col-md-6">
                <h5 style={{
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                  color: PrimaryTheme.primary,
                  textTransform: "uppercase",
                }}>Reference</h5>

                <p>{transactions.reference ? transactions.reference.length > 25 ? transactions.reference.substring(0, 25) + "\n" + transactions.reference.substring(25, transactions.reference.length) : transactions.reference : '-'}</p>
              </div>

              <div className="col-md-6">
                <h5 style={{
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                  textTransform: "uppercase",
                  color: PrimaryTheme.primary
                }}>Type</h5>

                <p>{transactions.transactionTypeName ? transactions.transactionTypeName : "-"}</p>
              </div>

              <div className="col-md-6">
                <h5 style={{
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                  textTransform: "uppercase",
                  color: PrimaryTheme.primary
                }}>Status</h5>

                <p>{transactions.statusName ? transactions.statusName : "-"}</p>
              </div>


              <div className="col-md-6">
                <h5 style={{
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                  color: PrimaryTheme.primary,
                  textTransform: "uppercase",
                }}>Agent</h5>

                <p>{transactions.agentName ? transactions.agentName : "-"}</p>
              </div>

              <div className="col-md-6">
                <h5 style={{
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                  textTransform: "uppercase",
                  color: PrimaryTheme.primary
                }}>Response Code</h5>

                <p>{transactions.responseCode ? transactions.responseCode : "-"}</p>
              </div>

              <div className="col-md-6">
                <h5 style={{
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                  color: PrimaryTheme.primary,
                  textTransform: "uppercase",

                }}>Commission</h5>

                <p>{transactions.aggregatorCommission ? getCurrency(transactions.aggregatorCommission) : "-"}</p>
              </div>


              <div className="col-md-6"  style={{background:"white"}}>
                <h5 style={{
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                  color: PrimaryTheme.primary,
                  textTransform: "uppercase",

                }}>Date</h5>

                <p>{transactions.transactionDate ? getDateTime(transactions.transactionDate) : "-"}</p>
              </div>

              <div className="col-md-6" style={{background:"white"}}>
                <h5 style={{
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                  textTransform: "uppercase",
                  color: PrimaryTheme.primary
                }}>Description</h5>

                <p>{transactions.description ? transactions.description : "-"}</p>
              </div>

              <div className="col-md-6">
                <h5 style={{
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                  color: PrimaryTheme.primary,
                  textTransform: "uppercase",
                }}>Charge</h5>

                <p>{transactions.banklyCharge ? getCurrency(transactions.banklyCharge) : "-"}</p>
              </div>

            </div>
          </div>

        </div>

      </div>
    </React.Fragment>
  )
}
